import React, { useEffect, useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import MemberRegistrationTypeForm from '../../../components/forms/MemberRegistrationTypeForm';
import { useMemberRegistrationTypeById, useUpdateMemberRegistrationType } from '../../../hooks/useMemberRegistrationTypeApi';
import { useNavigate, useParams } from 'react-router-dom';
import Card from '../../../components/common/Card';
import { MemberRegistrationTypeDTO } from '../../../services/apiClient';

const MemberRegistrationTypeEdit: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const { data: entityData, isLoading } = useMemberRegistrationTypeById(id!);
  const updateMutation = useUpdateMemberRegistrationType();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Member Registration Types', href: '/admin/memberregistrationtypes' },
    { label: 'Edit', href: '#' },
  ];

  const handleSubmit = async (data: any) => {
    try {
      await updateMutation.mutateAsync({ id: id!, data });
      navigate('/admin/memberregistrationtypes');
    } catch (error) {
      console.error('Error updating MemberRegistrationType:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/memberregistrationtypes"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Settings.MemberRegistrationType.Edit'
    >
        {entityData ? (
          <MemberRegistrationTypeForm
            initialValues={entityData}
            onSubmit={handleSubmit}
            onCancel={() => navigate('/admin/memberregistrationtypes')}
          />
        ) : (
          <p>Loading...</p>
        )}
    </AdminLayout>
  );
};

export default MemberRegistrationTypeEdit;